import React from 'react';
import {useAppSelector} from "../../hooks/redux";
import {toast} from "react-toastify";
import {getIsAuth} from "../../store/selectors/authSelector";
import {Navigate} from "react-router-dom";


const InitializationApp = (Component: React.FC) => {
    const WrapperComponent = (props: any) => {
        const isAuth = useAppSelector(getIsAuth)

        if (!isAuth) {
            toast.warning('Данная страница доступна только авторизованным пользователям')
            return <Navigate to={'/'}/>
        } else {
            return <Component {...props}/>
        }
    }

    return WrapperComponent
};

export default InitializationApp;